import React from "react";

function PatientPortal() {
  return <div>Patient Portal</div>;
}

export default PatientPortal;
